
export const API_KEY = 'KdGMmVqU247UBWyHvoPyGUcMUwxzhM4J';
export const CITY_URL = `https://dataservice.accuweather.com/locations/v1/cities/search/?`;
export const WEATHER_URL = `https://dataservice.accuweather.com/forecasts/v1/daily/5day/`;